import React, { Component } from "react";
import WebfineryNavbar from "./WebfineryNavbar";
import Footer from "./content/Footer.js";
import { LinkContainer } from "react-router-bootstrap";
import { Modal, Button, Alert, Grid, Row, Col } from "react-bootstrap";
import SearchHero from "./SearchHero";
import SearchResults from "./SearchResults";
import SearchLearn from "./SearchLearn";
import Plan from "./Plan";
import FeedbackForm from "./FeedbackForm";
import UserCondition from "./UserCondition";
import Helmet from "react-helmet";
import mixpanel from "mixpanel-browser";
import FileSaver from "file-saver";
import cookie from 'react-cookie';
import axios from "axios";


class SearchPage extends Component {
    optionsState(pristine) {
        let dataSet = this.dataSetState(pristine);
        let scope = this.scopeState(pristine);

        const options = {
            dataSet: dataSet,
            scope: scope
        };

        this.maxExportSize = 200;

        return options;
    }

    //keep this name, see handleOptionsChange
    dataSetState(pristine) {
        return [
            {
                id: "top10k",
                name: "Top 10k",
                selected: false,
                explainer: "top 10,000 websites",
                plan: "free"
            },
            {
                id: "top100k",
                name: "Top 100k",
                selected: false,
                explainer: "top 100,000 websites",
                plan: "free"
            },
            {
                id: "top500k",
                name: "Top 500k",
                selected: pristine,
                explainer: "top 500,000 websites",
                plan: "free"
            },
            {
                id: "top1m",
                name: "Top 1M",
                selected: false,
                explainer: "top 1 million websites",
                plan: "premium"
            },
            /*
            {
                id: "top10m",
                name: "Top 10M",
                selected: false,
                explainer: "top 10 million websites",
                plan: "premium"
            },
            */
            {
                id: "top200m",
                name: "All Sites",
                selected: false,
                explainer: "all available websites",
                plan: "premium"
            }
        ];
    }

    //keep this name, see handleOptionsChange
    scopeState(pristine) {
        return [
            {
                name: "All",
                selected: pristine,
                searchFields: ["content", "headerFields.*"],
                labelTypes: true,
                explainer: "JavaScript and HTML source code, and server HTTP headers",
                plan: "free"
            },
            {
                name: "JS & HTML",
                selected: false,
                searchFields: ["content"],
                labelTypes: false,
                explainer: "JavaScript and HTML source code",
                plan: "free"
            },
            {
                name: "JS",
                selected: false,
                searchFields: ["script"],
                labelTypes: false,
                explainer: "JavaScript source code",
                plan: "free"
            },
            {
                name: "Meta & Title",
                selected: false,
                searchFields: ["metaTags.*", "title"],
                labelTypes: true,
                explainer: "<meta> and <title> tags",
                plan: "free"
            },
            {
                name: "HTTP Headers",
                selected: false,
                searchFields: ["headerFields.*"],
                labelTypes: false,
                explainer: "server HTTP headers",
                plan: "free"
            }
            /*
            ,
            {
                name: "Text",
                selected: false,
                searchFields: ["text"],
                labelTypes: false,
                explainer: "visible text only",
                plan: "premium"
            }*/
        ];
    }

    constructor() {
        super();

        //TODO make it a user preference
        this.pageSize = 10;

        this.state = {
            hits: { hits: [], total: -1 },
            searchPristine: true,
            userQuery: "",
            optionsVisible: false,
            options: this.optionsState(true),
            exportModalVisible: false,
            exporting: false,
            optionExplainerMessage: "",
            upgradeModalVisible: false,
            error: false,
            componentDidMount: false,
            isLoggedIn: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitWithOptionsUpdate = this.handleSubmitWithOptionsUpdate.bind(this);
        this.handleOptionsClick = this.handleOptionsClick.bind(this);
        this.handlePageRequest = this.handlePageRequest.bind(this);
        this.handleOptionsChange = this.handleOptionsChange.bind(this);
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleCancelExport = this.handleCancelExport.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleOptionHover = this.handleOptionHover.bind(this);
        this.getHeroHeader = this.getHeroHeader.bind(this);
        this.handleCancelUpgrade = this.handleCancelUpgrade.bind(this);
        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.updateQuery = this.updateQuery.bind(this);
        this.hideSignupModal = this.hideSignupModal.bind(this);
        this.handleUpgradeRequest = this.handleUpgradeRequest.bind(this);

        this.mixpanel = mixpanel;

    }

    componentDidMount() {
    	this.loginStatusUpdate();
    	this.setState({componentDidMount: true});
    	window.scrollTo(0, 0)
    }

    loginStatusUpdate() {
    	let jwt = cookie.load('webfinery.jwt');
    	this.setState({isLoggedIn: jwt != null });
    }

    handleQueryChange(event) {
    	this.setState({userQuery: event.target.value});
    }

    updateQuery(newQueryValue) {    	
    	this.setState({userQuery: newQueryValue});
    }

    handleSubmitWithOptionsUpdate(fromIndex, query, dataSet, scope) {
    	let options = this.handleOptionsChange('dataSet', dataSet, this.state.options);
    	options = this.handleOptionsChange('scope', scope, options);
    	this.handleSubmit(fromIndex, query, options);
    }    

    handleSubmit(fromIndex, optionalQuery, optionalOptions) {

        if (!fromIndex) {
            fromIndex = 0;
        }

    	let searchQuery = null;
    	if (optionalQuery) {
    		this.setState({userQuery: optionalQuery});
    		searchQuery = optionalQuery;
    	} else {
    		searchQuery = this.state.userQuery;
    	}

    	if (!searchQuery || searchQuery.length < 3) {
    		return;
    	}

        //must be logged in to see more search results
        if (fromIndex > 0 && this.state.isLoggedIn === false) {
        	this.setState({signupModalVisible: true});
        	
            this.mixpanel.track("Signup modal via paging", {
                query: searchQuery,
	            dataSet: this.getSelected('dataSet').id,
    	        scope: this.getSelected('scope').name,
                success: false,                
                isLoggedIn: this.state.isLoggedIn
            });

            return;
        }
        
    	let dataSet = this.getSelected('dataSet', optionalOptions);
    	let scope = this.getSelected('scope', optionalOptions);

        this.props.router.push("/search");
        this.setState({ loading: true });
        this.setState({ error: false });
        this.setState({ searchPristine: false });
        this.setState({ optionsVisible: false }); //close options on submit

        /*
        console.log('QUERY', {
                    query: searchQuery,
                    from: fromIndex,
                    size: this.pageSize,
                    searchField: scope.searchFields,
                    dataSet: dataSet.id
                });
		*/

        let that = this;
        axios
            .get("/api/search", {
                params: {
                    query: searchQuery,
                    from: fromIndex,
                    size: this.pageSize,
                    searchField: scope.searchFields,
                    dataSet: dataSet.id
                }
            })
            .then(function(response) {
                that.setState({ loading: false });
                that.setState({ searchResults: response.data });

                that.mixpanel.track("Search", {
                    query: searchQuery,
                    dataSet: dataSet.id,
                    scope: scope.name,
                    success: true,
                    total: response.data.total,
                    took: response.data.took / 1000,
                    isLoggedIn: that.state.isLoggedIn
                });
            })
            .catch(function(error) {            	
                that.mixpanel.track("Search failed", {
                    query: searchQuery,
                    dataSet: dataSet.id,
                    scope: scope.name,                    
                    success: false,
                    error: error,
                    isLoggedIn: that.state.isLoggedIn 
                });
                that.setState({ searchResults: null });
                that.setState({error: true, loading: false});
            });
    }

    handleExportClick() {
    	if (this.state.isLoggedIn) {
        	this.setState({ exportModalVisible: true });
        } else {
        	this.setState({ signupModalVisible: true });
            this.mixpanel.track("Signup modal via export click", {
                query: this.state.userQuery,
				dataSet: this.getSelected('dataSet').id,
				scope: this.getSelected('scope').name,				
                success: false,
                isLoggedIn: this.state.isLoggedIn
            });
        }
    }

    handleExport() {
        this.setState({ exporting: true });

        let that = this;
        axios
            .get("/api/search/export", {
                params: {
                    query: that.state.userQuery,
                    timeout: 50 * 1000,
                    from: 0,
                    size: that.maxExportSize,
                    searchField: this.getSelected("scope").searchFields,
                    dataSet: this.getSelected("dataSet").id
                }
            })
            .then(function(response) {
                //safari issue - opens the file instead of triggering download, fix in 10.1
                let type = { type: "text/plain" }; //let type = {type: "text/csv;charset=utf-8"};
                let blob = new Blob([response.data], type);
                FileSaver.saveAs(blob, "webfinery-search.csv");
                that.setState({ exporting: false, exportModalVisible: false });
                that.mixpanel.track("Search export", {
                    query: that.state.userQuery,
					dataSet: that.getSelected('dataSet').id,
					scope: that.getSelected('scope').name,
                    success: true,
                    total: response.data.total,
                    took: response.data.took / 1000
                });
            })
            .catch(function(error) {
                that.setState({ exporting: false, exportModalVisible: false });
                that.mixpanel.track("Search export", {
                    query: that.state.userQuery,
                    success: false,
                    error: error
                });
            });
    }

    handleOptionsClick() {
        this.setState({ optionsVisible: !this.state.optionsVisible });
    }

    handlePageRequest(pageNumber) {
        let fromIndex = (pageNumber - 1) * this.pageSize;
        this.handleSubmit(fromIndex);
    }

    //pass prevOptions in case of subsequent synchronous calls to overcome async setState & race condition
    handleOptionsChange(part, name, prevOptions) {    	
        //clone
        let options = prevOptions ? prevOptions : Object.assign({}, this.state.options);
        
        //get new state for the part, e.g. dataSet
        let partState = this[part + "State"](false);
        
        //reset the part
        options[part] = partState;
        //find clicked option
        
        let option = options[part].find(obj => obj.name === name);
       	       	
       	if (typeof option.plan !== 'undefined' && option.plan === "premium") {
       		this.setState({ upgradeModalVisible: true });
       		return;
       	}

        option.selected = true;
        this.setState({ options: options });

        if (!this.state.searchPristine) {
        	this.handleSubmit(0, this.state.userQuery, options);
        }
        return options;
    }

    handleCancelExport() {
        this.setState({ exportModalVisible: false });
        this.mixpanel.track("Export canceled", {
            query: this.state.userQuery,
            dataSet: this.getSelected('dataSet').id,
            scope: this.getSelected('scope').name,
            success: false
        });        
    }

    getSelected(part, optionalOptions) {    	
    	const options = !optionalOptions ? this.state.options : optionalOptions;    	
        return options[part].find(option => option.selected === true);
    }

    getOption(part, optionName) {
        return this.state.options[part].find(
            option => option.name === optionName
        );
    }

    handleOptionHover(part, optionName) {
        this.setState({
            optionExplainerMessage: "Search in " +
                this.getOption(part, optionName).explainer
        });
    }

    getHeroHeader() {

    	let explainer = this.getSelected('dataSet').explainer;

    	if (this.getSelected('dataSet').plan === "free") {
    		return "Search across " + explainer + " for free"
    	} else {
    		//TODO and user isn't logged in and upgraded
    		return "Upgrade to search in " + explainer;
    	}
    }

    handleCancelUpgrade() {
    	this.setState({ upgradeModalVisible: false});
        this.mixpanel.track("Upgrade modal closed", {
            query: this.state.userQuery,
			dataSet: this.getSelected('dataSet').id,
			scope: this.getSelected('scope').name,
            success: false
        });
    }

    handleUpgradeRequest() {
    	this.setState( { exportModalVisible: false });
    	this.setState( { upgradeModalVisible: true});
    }

    renderUpgradeModal() {
        return (
            <div className="static-modal">

                <Modal show={this.state.upgradeModalVisible} bsSize="large">
                    <Modal.Header closeButton={true} onHide={this.handleCancelUpgrade}>
                        
                    </Modal.Header>

                    <Modal.Body>
                        <div className="text-center">
                            <h2>Upgrade Options</h2>
                            <Grid fluid={true}>
                            	<Row>
                            		<Col md={6}>
                            			<Plan className="plan-pro" name="pro" subtitle="top sites & tail" price="$49 / month" dataSet="Large" export="Extended" depth="Front page">
                            				<FeedbackForm submitLabel="Request access" list="upgrade-pro" doneMessage="Registered. Await an email from us."></FeedbackForm>
                            			</Plan>
                            		</Col>                            	
                            		<Col md={6}>
										<Plan className="plan-dedicated" name="dedicated" subtitle="Any sites" price="Contact us" dataSet="Unlimited" export="Unlimited" depth="Unlimited">
											<a href="mailto:sales@webfinery.com">
										     	<Button bsStyle="primary">Get in touch</Button>
										     </a>
										</Plan>                            		
                            		</Col>
                            	</Row>
                            	<Row>
                            		<Col md={12}>
										<UserCondition isLoggedIn={false}>
											<div>You are not logged in</div>
											<br />
					                        <LinkContainer to="/signup?plan=basic">
						                        <Button bsStyle="default">
						                            Sign up for our FREE Basic Plan
						                        </Button>
						                    </LinkContainer>    	
			                            </UserCondition>
                            		</Col>
                            	</Row>
                            </Grid>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>

                </Modal>
            </div>
        );

    }

    hideSignupModal() {
    	this.setState({signupModalVisible: false});
        this.mixpanel.track("Signup modal closed", {
            query: this.state.userQuery,
            dataSet: this.getSelected('dataSet').id,
            scope: this.getSelected('scope').name,
            success: false
        });
    }

    renderSignupModal() {

    	const style = { background: '#2a1e3c' }

        return (
            <div className="static-modal">

                <Modal show={this.state.signupModalVisible} >
                	<Modal.Header closeButton={true} onHide={this.hideSignupModal}>
                	</Modal.Header>
                    <Modal.Body>
                        <div className="text-center">                    
                        	<h2 style={{color: '#6067FF'}}>Free Search &amp; Export</h2>
							<h1>
	                            <i
	                                className="fa fa-check-square-o fa-3x"
	                                aria-hidden="true"
	                            />
	                        </h1>	                            
                            <h3 style={{color: 'green', fontWeight: 'bold'}}>Search Top 500,000 Websites for Free</h3>
                            <p>Access millions of websites after upgrade (optional)</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer style={style}>
                    	<LinkContainer to="/signup">
	                        <Button bsStyle="success">
	                            Sign up for FREE &amp; see more now
	                        </Button>	                        
	                    </LinkContainer>
	                    <div><small>No credit card required. Ultra-fast.</small></div>
                    </Modal.Footer>

                </Modal>
            </div>
        );
    }


    renderSearchHero() {
        return (
            <SearchHero
                searchPristine={this.state.searchPristine}
                handleSubmit={this.handleSubmit}
                handleOptionsClick={this.handleOptionsClick}
                handleOptionHover={this.handleOptionHover}
                loading={this.state.loading}
                optionsVisible={this.state.optionsVisible}
                options={this.state.options}
                handleQueryChange={this.handleQueryChange}
                handleOptionsChange={this.handleOptionsChange}
                explainerMessage={this.state.optionExplainerMessage}
                heroHeader={this.getHeroHeader()}
                userQuery={this.state.userQuery}
            />
        );
    }

    renderExportModal() {

        const resultsTotal = this.state.searchResults != null
            ? this.state.searchResults.hits.total
            : 0;
        const exportSize = Math.min(this.maxExportSize, resultsTotal);
        const limitMessage = resultsTotal > this.maxExportSize
            ? (<div>
            		<Alert bsStyle="danger">
                	  (Size reduced to maximum free allowance)
              	</Alert>
              	<br/>
              	<Button bsSize="small" bsStyle="primary" onClick={this.handleUpgradeRequest}>Upgrade to remove this limitation</Button>
              </div>)
            : "";

        const exportLabel = this.state.exporting ? "Exporting..." : "Export";

        return (
            <div className="static-modal">

                <Modal show={this.state.exportModalVisible}>
                    <Modal.Header>
                        <Modal.Title>Export to CSV File</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="text-center">
                            <h2>List of {exportSize} Websites</h2>
                            {limitMessage}
                            <h2>
                                <em style={{ color: "green" }}>
                                    {this.state.userQuery}
                                </em>
                            </h2>
                            <h1>
                                <i
                                    className="fa fa-arrow-circle-o-down fa-3x"
                                    aria-hidden="true"
                                />
                            </h1>
                            <h4>
                                Found in{" "}
                                {this.getSelected("scope").explainer}
                                {" "}across{" "}
                                {this.getSelected("dataSet").explainer}
                            </h4>                            
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            disabled={this.state.exporting}
                            onClick={this.handleCancelExport}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={this.state.exporting}
                            bsStyle="success"
                            onClick={this.handleExport}
                        >
                            {exportLabel}
                        </Button>
                    </Modal.Footer>

                </Modal>
            </div>
        );    	
    }

    renderSeachResults() {
        return (
            <SearchResults
                loading={this.state.loading}
                searchResults={this.state.searchResults}
                handlePageRequest={this.handlePageRequest}
                pageSize={this.pageSize}
                handleExportClick={this.handleExportClick}                
                handleUpgradeRequest={this.handleUpgradeRequest}
                userQuery={this.state.userQuery}
                dataSet={this.getSelected('dataSet').name}
				handleSubmitWithOptionsUpdate={this.handleSubmitWithOptionsUpdate}
            />
        );
    }

    renderSearchError() {
        return (
        	<Grid>
        		<Row>
        			<Col sm={12} className="text-center">
        				<h3>Update in progress...</h3>
        				<p>Search data is currently being updated. Please check back in a while.<br />
        				If you have any questions, please contact us at support@webfinery.com.<br />
        				Apologies for the inconvenience.</p>
        				<a href="/">
        					<Button bsStyle="default">Main Page</Button>
        				</a>
        			</Col>
        		</Row>
        	</Grid>
        );
    }


    render() {

        function mainRender() {

	        return (
	            <div>
	            	<Helmet title="Web Source Code Search"/>

	                <WebfineryNavbar
	                    routePath={this.props.route.path}
	                    userQuery={this.state.userQuery}
	                    searchPristine={this.state.searchPristine}
	                    handleSubmit={this.handleSubmit}
	                    loading={this.state.loading}
	                    handleOptionsClick={this.handleOptionsClick}
	                    optionsVisible={this.state.optionsVisible}
	                    options={this.state.options}
	                    handleQueryChange={this.handleQueryChange}
	                    handleOptionsChange={this.handleOptionsChange}
	                    handleOptionHover={this.handleOptionHover}                    
	                />

					{this.state.componentDidMount && this.renderSearchHero()}

	                {this.state.componentDidMount && this.state.searchResults &&
	                    this.state.searchResults.hits.total >= 0
	                    ? this.renderSeachResults()
	                    : null}
	               
	                {this.state.componentDidMount && this.state.error ? this.renderSearchError() : null}

					{this.state.componentDidMount && this.renderExportModal()}
					{this.state.componentDidMount && this.renderUpgradeModal()}
					{this.state.componentDidMount && this.renderSignupModal()}
	               
					{this.state.searchPristine ? <SearchLearn handleSubmitWithOptionsUpdate={this.handleSubmitWithOptionsUpdate}></SearchLearn> : null}
	            	
	                <Footer className="app-footer" />

	            </div>
	        );
    	}
    	

    	//return <h3>googlebot test 3</h3>
    	return mainRender.bind(this)();
    }
}

export default SearchPage;



// WEBPACK FOOTER //
// ./src/SearchPage.js